import React from "react";
import { useTranslation } from "react-i18next";
import { Tooltip } from "src/ui/shared/Tooltip";

import { styled, useTheme } from "@mui/material";

const Container = styled("div")({
    fontSize: 16,
    lineHeight: "18.62px",
    flexShrink: 0,
    flex: 0.3,
    display: "flex",
    alignItems: "center",
});

export const BuildVariantLabel = (props: React.PropsWithChildren<{ style?: React.CSSProperties }>) => {
    const theme = useTheme();
    const { t } = useTranslation(["common"]);

    return (
        <Container {...props}>
            {props.children}
            <Tooltip
                title={
                    <>
                        {t("common:section.buildVariant.header")}:
                        <ul style={{ paddingLeft: theme.spacing(5) }}>
                            <li style={{ marginTop: theme.spacing(1) }}>
                                <strong>{t("common:section.buildVariant.user.title")}:</strong>{" "}
                                {t("common:section.buildVariant.user.description")}
                            </li>
                            <li style={{ marginTop: theme.spacing(1) }}>
                                <strong>{t("common:section.buildVariant.userdebug.title")}:</strong>{" "}
                                {t("common:section.buildVariant.userdebug.description")}
                            </li>
                            <li style={{ marginTop: theme.spacing(1) }}>
                                <strong>{t("common:section.buildVariant.eng.title")}:</strong>{" "}
                                {t("common:section.buildVariant.eng.description")}
                            </li>
                        </ul>
                    </>
                }
            >
                <i className="fas fa-info-circle" />
            </Tooltip>
        </Container>
    );
};
